import React from 'react'
import { useTranslation } from 'react-i18next'
import { Grid, withStyles } from '@material-ui/core'
import { Label } from '../../default'
import TableLog from './TableLog'
import { CardSearchLog } from '../../cards'

const PanelLog = ({ classes }) => {

  const { t } = useTranslation()

  return (
    <Grid container spacing={3} className={classes.root}>

      <Grid item xs={12}>
        <Label v='h5' bold>{t('panels.managerLog.title')}</Label>
      </Grid>

      <Grid item xs={12}>
        <CardSearchLog />
      </Grid>

      <Grid item xs={12}>
        <TableLog />
      </Grid>
      
    </Grid>
  )
}

const styles = theme => ({
  root: {
    display: 'flex',
    flex: 1
  }
})

export default withStyles(styles)(PanelLog)